import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { images } from "../../helpers/images";
import { onClickWhiteLabelSignin } from "../../modules/actions/";
import { authUserData } from "../../helpers";
import Toast from "../../components/Toast";

class WhiteLabelSignin extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      subdomain: "",
      email: "",
      password: "",
      disableButton: false,
    };
  }

  componentDidMount() {
    const hostname = window.location.hostname;
    const parts = hostname.split(".");
    const subdomain = parts[0];

    this.setState({
      subdomain: subdomain,
    });

    const userData = authUserData();

    if (userData && userData.accessToken) {
      this.props.history.push("/dashboard");
    }
  }

  onChangeHandelUserInput = (evt) => {
    const name = evt.target.name;
    const value = evt.target.value;

    this.setState({
      [name]: value,
    });
  };

  onClickWhiteLabelSignin = () => {
    this.setState({ disableButton: true });

    let formData = {
      subdomain: this.state.subdomain,
      email: this.state.email,
      password: this.state.password,
    };

    this.props.onClickWhiteLabelSignin(formData);

    setTimeout(
      () =>
        this.setState({
          email: "",
          password: "",
          disableButton: false,
        }),
      2500
    );
  };

  onTextKeyPress = (evt) => {
    if (evt.key === "Enter") {
      this.onClickWhiteLabelSignin();
    }
  };

  render() {
    const { email, password, disableButton } = this.state;

    return (
      <div className="grid-container full">
        <ToastContainer />

        <div className="grid-x  grid-margin-x" id="container">
          <div className="cell small-12 medium-5" id="infoplatesection">
            <div id="logosection">
              <img src={images.logo} />
            </div>

            <div id="infotxt">
              White label signup here
              <br />
              and create
            </div>

            <div id="infobutton">
              <Link to="/register">
                <button className="button login" id="loginBtn">
                  Register
                </button>
              </Link>
              {/* <p> or </p>{" "}
              <button
                className="button login"
                id="loginBtn"
                onClick={() => {
                  window.location.href =
                    "http://saqgenerator.local/white-label/subdomain";
                }}
              >
                Enter Subdomain
              </button> */}
            </div>
          </div>
          <div className="cell small-12 medium-7" id="formsection">
            <div id="registersaq" className="show">
              <h3 style={{ paddingTop: "320px" }}>Sign in</h3>
              <p>Sign in to your white label account.</p>
              <div className="grid-container" id="formfieldscontainer">
                <div className="grid-y grid-x">
                  <div className="small-12 medium-8 cell">
                    <label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter email"
                        name="email"
                        value={email}
                        onChange={(evt) => this.onChangeHandelUserInput(evt)}
                        onKeyPress={(evt) => this.onTextKeyPress(evt)}
                      />
                    </label>
                  </div>
                  <div className="small-12 medium-8 cell">
                    <label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter password"
                        name="password"
                        value={password}
                        onChange={(evt) => this.onChangeHandelUserInput(evt)}
                        onKeyPress={(evt) => this.onTextKeyPress(evt)}
                      />
                    </label>
                  </div>
                </div>
                <div id="fieldbuttons">
                  <button
                    className="button nxt-btn"
                    onClick={() => this.onClickWhiteLabelSignin()}
                    disabled={disableButton}
                  >
                    Log in
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ onClickWhiteLabelSignin }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(WhiteLabelSignin);
